import { clean_string } from "@/utils/global";
import i18n from "@/i18n";
import { TranslateResult } from "vue-i18n";
import { ExtractedSkillsWithGroup } from "@/interfaces/responses/extracted_skills_with_group";

export interface SkillsGroup {
  skill_group: TranslateResult;
  value: string;
  class: string;
  active_class: string;
  icon: string;
  color: string;
  transform_source: (icon: HTMLElement) => HTMLElement;
}
export const skills_group: SkillsGroup[] = [
  {
    skill_group: i18n.t("skill-group.leader-title"),
    value: "Leadership and Management",
    class: "leadership-management",
    active_class: "active",
    icon: require("@/assets/icons/bold/personalcard.svg"),
    color: "#FF4066",
    transform_source: (icon: HTMLElement): HTMLElement => {
      for (const node of icon.children) node.setAttribute("fill", "#FF4066");
      return icon;
    }
  },
  {
    skill_group: i18n.t("skill-group.soft-title"),
    value: "Soft skills",
    class: "soft-skills",
    active_class: "active",
    icon: require("@/assets/icons/bold/simcard.svg"),
    color: "#FFB815",
    transform_source: (icon: HTMLElement): HTMLElement => {
      for (const node of icon.children) node.setAttribute("fill", "#FFB815");
      return icon;
    }
  },
  {
    skill_group: i18n.t("skill-group.it-title"),
    value: "IT and Software",
    class: "it-software",
    active_class: "active",
    icon: require("@/assets/icons/bold/recovery-convert.svg"),
    color: "#3C63B6",
    transform_source: (icon: HTMLElement): HTMLElement => {
      for (const node of icon.children) node.setAttribute("fill", "#3C63B6");
      return icon;
    }
  },

  {
    skill_group: i18n.t("skill-group.domain-title"),
    value: "Hard skills",
    class: "domain-specific",
    active_class: "active",
    icon: require("@/assets/icons/bold/ruler&pen.svg"),
    color: "#FF8473",
    transform_source: (icon: HTMLElement): HTMLElement => {
      for (const node of icon.children) node.setAttribute("fill", "#FF8473");
      return icon;
    }
  },
  {
    skill_group: i18n.t("skill-group.green-title"),
    value: "Green Skills",
    class: "green-skills",
    active_class: "active",
    icon: require("@/assets/icons/bold/triangle.svg"),
    color: "#3CE17E",
    transform_source: (icon: HTMLElement): HTMLElement => {
      for (const node of icon.children) node.setAttribute("fill", "#3CE17E");
      return icon;
    }
  }
];

/**
 * Return skill group class names
 * @param skill_group
 * @param active_skill_group
 * @return string => class name
 */
export function extract_skill_group_styling(
  skill_group: string,
  active_skill_group: string
): string {
  skill_group = clean_string(skill_group);
  let tmp = skill_group;
  if (skill_group === "soft") tmp = "soft skills";
  if (skill_group === "hardware" || skill_group === "hard") tmp = "hard skills";
  if (skill_group === "green") tmp = "green skills";
  const obj = skills_group.find(
    (val: SkillsGroup) => clean_string(val.value) === tmp
  );
  if (!obj) return "";
  if (clean_string(active_skill_group) === tmp)
    return `${obj.active_class} ${obj.class}`;
  else return obj.class;
}

export function get_skill_group_name(group: string): string {
  const skill_group = clean_string(group);
  let tmp = skill_group;
  if (skill_group === "soft") tmp = "soft skills";
  if (skill_group === "hardware" || skill_group === "hard") tmp = "hard skills";
  if (skill_group === "green") tmp = "green skills";
  const obj = skills_group.find(
    (val: SkillsGroup) => clean_string(val.value) === tmp
  );

  return obj ? (obj.skill_group as string) : "Skills";
}

/**
 * Function to return skills group
 * @return SkillsGroup[]
 */
export function get_skills_group(): SkillsGroup[] {
  return skills_group;
}

export function filter_skills_based_on_group(
  skills: ExtractedSkillsWithGroup.Skills[],
  active_skill_group: string
): ExtractedSkillsWithGroup.Skills[] {
  return skills.filter((skill) => {
    const skill_group = clean_string(skill.group);
    let tmp = skill_group;
    if (skill_group === "soft") tmp = "soft skills";
    if (skill_group === "hardware" || skill_group === "hard")
      tmp = "hard skills";
    if (skill_group === "green") tmp = "green skills";
    if (clean_string(active_skill_group) === tmp) return skill;
  });
}
